import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  reflexPanelsService,
  type CreatePathologistPanelInput,
} from "../services/reflexPanels.service";
import type { AdditionalStainRequestSurface } from "../services/stainRequest.service";

export function useCreatePathologistPanelOrder(
  surface: AdditionalStainRequestSurface = "pathologist-review"
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      caseId,
      input,
    }: {
      caseId: string;
      input: CreatePathologistPanelInput;
    }) => reflexPanelsService.createPathologistPanel(caseId, input, surface),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["pathologist-review", variables.caseId, "panels"],
      });
      queryClient.invalidateQueries({
        queryKey: ["case-for-pathologist-review", variables.caseId],
      });
      queryClient.invalidateQueries({ queryKey: ["pathologist-review-queue"] });
      queryClient.invalidateQueries({ queryKey: ["stain-requests"] });
      queryClient.invalidateQueries({ queryKey: ["case", variables.caseId] });
      queryClient.invalidateQueries({
        queryKey: ["case-additional-stains", variables.caseId],
      });
    },
  });
}
